import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "plan__date" }
const _hoisted_2 = { style: {"display":"none"} }
const _hoisted_3 = { class: "billing-period-end" }
const _hoisted_4 = { class: "billing-period-end-local" }
const _hoisted_5 = { class: "billing-trial-start" }
const _hoisted_6 = { class: "billing-trial-start-local" }
const _hoisted_7 = { class: "billing-trial-end" }
const _hoisted_8 = { class: "billing-trial-end-local" }
const _hoisted_9 = { class: "plan__date-text" }
const _hoisted_10 = { class: "plan__date-text--black-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "plan__date-text--black-text plan__date-date" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "plan__date-text--black-text plan__date-date" }
const _hoisted_15 = { class: "plan__date-text--black-text plan__date-date wg-no-translate" }
const _hoisted_16 = {
  key: 0,
  class: "plan__date-text plan__trial-info"
}

import type { BillingView } from '@/models/billing'

import { formatTrialDateDebug } from '@/helpers/time'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaid.PlanDate',
  props: {
    billing: {}
  },
  setup(__props: any) {



function formatDateDebug(dt: string): string {
  return formatTrialDateDebug(dt)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.billing.current_period_end_datetime), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(formatDateDebug(__props.billing.current_period_end_datetime)), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.billing.trial_start_datetime), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.billing.trial_start_datetime &&
          formatDateDebug(__props.billing.trial_start_datetime)), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.billing.trial_end_datetime), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.billing.trial_end_datetime &&
          formatDateDebug(__props.billing.trial_end_datetime)), 1)
    ]),
    _createElementVNode("p", _hoisted_9, [
      _cache[4] || (_cache[4] = _createTextVNode(" Billed ", -1)),
      _createElementVNode("span", _hoisted_10, "once per " + _toDisplayString(__props.billing.plan.labels.period) + ".", 1),
      (__props.billing.cancel_at_period_end)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
            _cache[0] || (_cache[0] = _createTextVNode(" Active until ", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(__props.billing.billingPeriodEnd) + ".", 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_13, [
            _cache[1] || (_cache[1] = _createTextVNode(" Next billing on ", -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(__props.billing.billingPeriodEnd) + ".", 1),
            _cache[2] || (_cache[2] = _createTextVNode(" You will be charged ", -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(__props.billing.nextBillingPrice.perPeriod), 1),
            _cache[3] || (_cache[3] = _createTextVNode(" on this date. ", -1))
          ]))
    ]),
    (__props.billing.is_trial)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
          _cache[5] || (_cache[5] = _createTextVNode(" Trial period: ", -1)),
          _createElementVNode("span", null, _toDisplayString(__props.billing.trialMode), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})